<template>
  <q-list separator>
    <q-collapsible
      v-for="unit in validateProp.units.$each.$iter"
      :key="unit.$model.id"
      group="units"
      :icon="unit.$model.showing_enabled ? 'toggle_on' : 'toggle_off'"
      :class="unit.$model.showing_enabled ? 'text-positive' : 'text-negative'"
      :label="unit.$model.name || currentProperty.short_address"
      :opened="true"
    >
      <div class="text-black">
        <ul>
          <li v-if="editMode">
            <strong>Unit name: </strong>
            <q-field
              :error="unit.name.$error"
              error-label="This field is required"
            >
              <q-input
                v-model="unit.$model.name"
                :disable="hasAppfolioNewIntergation"
              />
            </q-field>
            <strong>Unit override AppFolio property code: </strong>
            <q-field>
              <q-input v-model="unit.$model.pms_code" />
            </q-field>
          </li>
          <li>
            <strong>Created at: </strong>
            <SdDatetime
              :value="unit.$model.created_at"
              :market-id="currentProperty.market_id"
              :timezone="currentProperty.timezone"
              class="inline-block"
            />
          </li>
          <li>
            <span v-html="getListingContact()" />
          </li>
          <li>
            <strong>Active for showings: </strong>
            <span :class="unit.$model.showing_enabled ? 'text-positive' : 'text-negative'">{{ unit.$model.showing_enabled ? 'Yes' : 'No' }}</span>
          </li>
          <li v-if="unit.$model.last_showing_profile">
            <strong>{{ unit.$model.showing_enabled ? 'Activation time' : 'Last activation time' }}: </strong>
            <SdDatetime
              :value="unit.$model.last_showing_profile.created_at"
              :market-id="currentProperty.market_id"
              :timezone="currentProperty.timezone"
              class="inline-block"
            />
          </li>
          <li v-if="unit.$model.last_showing_profile && !unit.$model.showing_enabled">
            <strong>Inactivation time: </strong>
            <SdDatetime
              :value="unit.$model.last_showing_profile.deleted_at"
              :market-id="currentProperty.market_id"
              :timezone="currentProperty.timezone"
              class="inline-block"
            />
          </li>
          <li v-if="unit.$model.last_showing_profile && !unit.$model.showing_enabled">
            <strong>Deactivation reason: </strong>
            <span>{{ getDeactivationReason(unit.$model.last_showing_profile) }}</span>
          </li>
          <li v-if="unit.$model.last_showing_profile">
            <strong>Tours count: </strong> {{ unit.$model.last_showing_profile.tours_count }}
          </li>
          <template v-if="unit.$model.last_showing_profile && !unit.$model.last_showing_profile.is_vacant && unit.$model.last_showing_profile.tenants">
            <li>
              Tenants:
              <ul>
                <li
                  v-for="(tenant, index) in unit.$model.last_showing_profile.tenants"
                  :key="`tenant_${index}`"
                  class="my-2"
                >
                  <strong>{{ tenant.full_name }}</strong>
                  <a
                    v-if="tenant.formatted_phone_number"
                    class="mx-2"
                    :href="'tel:' + tenant.formatted_phone_number"
                  >{{ tenant.formatted_phone_number }}</a>
                  <a
                    v-if="tenant.email"
                    class="mx-2"
                    :href="'mailto:' + tenant.email"
                  >{{ tenant.email }}</a>
                </li>
              </ul>
            </li>
          </template>
          <li v-if="unit.$model.last_showing_profile && !unit.$model.listing_identifier">
            <strong>Property URL: </strong>
            <q-field
              v-if="editMode && unit.$model.last_showing_profile.deleted_at === null"
              :error="unit.last_showing_profile.property_url.$error"
              error-label="This field is required"
            >
              <q-input v-model="unit.$model.last_showing_profile.property_url" />
            </q-field>
            <a
              v-else
              :href="unit.$model.last_showing_profile.property_url"
              target="_blank"
            >{{ unit.$model.last_showing_profile.property_url }}</a>
          </li>
          <li v-if="unit.$model.last_showing_profile && unit.$model.last_showing_profile.syndication_status">
            <p
              v-for="syndication in unit.$model.last_showing_profile.syndication_status"
              :key="syndication.url"
            >
              portal: {{ syndication.portal }} - {{ syndication.url }}
            </p>
          </li>
          <li v-if="unit.$model.last_showing_profile">
            <strong>Application form URL: </strong>
            <q-field
              v-if="editMode && unit.$model.last_showing_profile.deleted_at === null"
              :error="unit.last_showing_profile.application_form_url.$error"
              error-label="This field is required"
            >
              <q-input v-model="unit.$model.last_showing_profile.application_form_url" />
            </q-field>
            <a
              v-else
              :href="unit.$model.last_showing_profile.application_form_url"
              target="_blank"
            >{{ unit.$model.last_showing_profile.application_form_url }}</a>
          </li>
          <li
            v-if="resolveSmartDevice(unit.$model)"
          >
            <strong>{{ capitalizeFirstLetter(unit.$model.last_showing_profile.access_hardware) }} serial number: </strong>
            <span>{{ unit.$model.last_showing_profile.device.serial_number }}</span>
          </li>
          <li
            v-if="unit.$model.last_showing_profile && !smartDeviceProviders.includes(unit.$model.last_showing_profile.access_hardware)"
          >
            <strong>{{ capitalizeFirstLetter(unit.$model.last_showing_profile.access_hardware || 'Access') }} code: </strong>
            <q-field
              v-if="editMode && unit.$model.last_showing_profile.deleted_at === null"
              :error="unit.last_showing_profile.lock_box_code.$error"
              error-label="This field is required"
            >
              <q-input v-model="unit.$model.last_showing_profile.lock_box_code" />
            </q-field>
            <span v-else>{{ unit.$model.last_showing_profile.lock_box_code }}</span>
          </li>
          <li
            v-if="unit.$model.last_showing_profile && unit.$model.last_showing_profile.type !== ShowingTypes.PUBLISH_LISTING"
            class="notes-to-agent"
          >
            <strong>Notes to agent: </strong>
            {{ editMode ? '' : unit.$model.last_showing_profile.comments }}
            <q-field
              v-if="editMode && unit.$model.last_showing_profile.deleted_at === null"
              :error="unit.last_showing_profile.comments.$error"
              error-label="This field is required"
            >
              <q-input
                v-model="unit.$model.last_showing_profile.comments"
                type="textarea"
              />
            </q-field>
          </li>
          <li v-if="unit.$model.last_showing_profile">
            <strong>Notes to prospect: </strong> {{ editMode ? '' : unit.$model.last_showing_profile.general_notes }}
            <q-field
              v-if="editMode && unit.$model.last_showing_profile.deleted_at === null"
              :error="unit.last_showing_profile.comments.$error"
              error-label="This field is required"
            >
              <q-input
                v-model="unit.$model.last_showing_profile.general_notes"
                type="textarea"
              />
            </q-field>
          </li>
          <li v-if="unit.$model.last_showing_profile && unit.$model.last_showing_profile.paused_until !== null">
            <strong>Showing paused until: </strong>
            <span v-if="unit.$model.last_showing_profile.paused_until === Property.INDEFINITE_PAUSE_TIME">
              Paused indefinitely
            </span>
            <SdDatetime
              v-else
              :value="unit.$model.last_showing_profile.paused_until"
              :market-id="currentProperty.market_id"
              :timezone="currentProperty.timezone"
              class="inline-block"
            />
          </li>
          <li
            v-if="unit.$model.last_showing_profile
              && currentProperty.market_id
              && !unit.$model.last_showing_profile.is_self_showing
              && !unit.$model.last_showing_profile.deleted_at"
          >
            <q-item>
              <q-item-main>
                <q-item-tile label>
                  Tour budget
                </q-item-tile>
                <q-item-tile
                  sublabel
                  v-html="getTourBudgetSubLabel(unit.$model.last_showing_profile)"
                />
              </q-item-main>
            </q-item>
          </li>
          <template v-if="!editMode && unit.$model.last_showing_profile && unit.$model.last_showing_profile.deleted_at === null" />
          <template v-if="!editMode && unit.$model.last_showing_profile">
            <template v-if="unit.$model.last_showing_profile.deleted_at === null">
              <li>
                <strong>Scheduling Link: </strong>
                <a
                  :href="unit.$model.landing_page_url.includes('http') ? unit.$model.landing_page_url : '//' + unit.$model.landing_page_url"
                  target="_blank"
                >{{ unit.$model.landing_page_url }}</a>
              </li>
              <li v-if="unit.$model.last_showing_profile.is_vacant === false">
                <strong>Tenant Schedule Link: </strong>
                <a
                  :href="unit.$model.landing_page_url.includes('http') ? unit.$model.landing_page_url + '/t' : '//' + unit.$model.landing_page_url + '/t'"
                  target="_blank"
                >{{ unit.$model.landing_page_url + '/t' }}</a>
              </li>
              <li v-if="unit.$model.last_showing_profile.formatted_phone_line">
                <strong>Phone Line: </strong>
                <a
                  :href="`tel:${unit.$model.last_showing_profile.formatted_phone_line}`"
                  target="_blank"
                >{{ unit.$model.last_showing_profile.formatted_phone_line }}</a>
              </li>
            </template>
            <li>
              <strong>Pre-screening: </strong>
              {{ unit.$model.last_showing_profile.pre_screening_disabled_at ? 'Disabled' : 'Enabled' }}
            </li>
            <li>
              <strong>Showing type: </strong>
              {{ ShowingTypesDisplay[unit.$model.last_showing_profile.type] }}
            </li>
          </template>
          <template v-if="!editMode && unit.$model.last_showing_profile && unit.$model.last_showing_profile.showing_windows.length">
            <li>
              <strong>Showing windows: </strong>
              <q-chip
                v-for="showingWindow in unit.$model.last_showing_profile.showing_windows"
                :key="showingWindow.id"
                dense
                class="q-mr-xs"
              >
                {{ moment.weekdays()[showingWindow.week_day].substring(0, 3) }}:
                {{ moment(showingWindow.from_hour, 'HH:mm:ss').format('h:mm A') }} - {{ moment(showingWindow.to_hour, 'HH:mm:ss').format('h:mm A') }}
                - {{ showingWindowAssigneeNames(showingWindow) }}<span
                  v-if="showingWindowAssignmentStrategyLabel(showingWindow)"
                  class="text-grey-7 q-ml-xs"
                >
                  ({{ showingWindowAssignmentStrategyLabel(showingWindow) }})
                </span>
              </q-chip>
            </li>
            <li>
              <strong>Showdigs agent backup: </strong>
              {{ unit.$model.last_showing_profile.is_agent_backup_enabled ? 'Enabled' : 'Disabled' }}
            </li>
          </template>
          <li v-if="!editMode && resolvePropertyScreening(unit.$model.last_showing_profile, 'minimum_credit_score')">
            <strong>Minimum credit score:</strong>
            {{ resolvePropertyScreening(unit.$model.last_showing_profile, 'minimum_credit_score') }}
          </li>
          <li v-if="!editMode && resolvePropertyScreening(unit.$model.last_showing_profile, 'minimum_income_rent_ratio')">
            <strong>Minimum income to rent ratio:</strong>
            {{ resolvePropertyScreening(unit.$model.last_showing_profile, 'minimum_income_rent_ratio') }}
          </li>
          <li v-if="!editMode && resolvePropertyScreening(unit.$model.last_showing_profile, 'eviction_history')">
            <strong>eviction history policy:</strong>
            {{ resolvePropertyScreening(unit.$model.last_showing_profile, 'eviction_history') }}
          </li>
          <li v-if="!editMode && resolvePropertyScreening(unit.$model.last_showing_profile, 'smoking_policy')">
            <strong>smoking policy:</strong>
            {{ resolvePropertyScreening(unit.$model.last_showing_profile, 'smoking_policy') }}
          </li>
          <li v-if="!editMode && resolvePropertyScreening(unit.$model.last_showing_profile, 'pet_policy')">
            <strong>pet policy:</strong>
            {{ resolvePropertyScreening(unit.$model.last_showing_profile, 'pet_policy') }}
          </li>
          <li v-if="!editMode && get(unit.$model.last_showing_profile, 'screening_criteria.availability_date')">
            <strong>Availability Date</strong>
            From {{ momentUtil(unit.$model.last_showing_profile.screening_criteria.availability_date, currentProperty.timezone).toDisplayMonthAndDayFormat() }}
          </li>
          <li v-if="!editMode && resolveShowingScreening(unit.$model.last_showing_profile, 'move_in_date')">
            <strong>Expected move in date</strong>
            {{ resolveShowingScreening(unit.$model.last_showing_profile, 'move_in_date') }}
          </li>
          <li v-if="!editMode && resolveShowingScreening(unit.$model.last_showing_profile, 'move_in_cost')">
            <strong>Move in cost:</strong>
            ${{ resolveShowingScreening(unit.$model.last_showing_profile, 'move_in_cost') }}
          </li>
          <li v-if="!editMode&& resolveShowingScreening(unit.$model.last_showing_profile, 'maximum_allowed_tenants')">
            <strong>Maximum allowed tenants:</strong>
            {{ resolveShowingScreening(unit.$model.last_showing_profile, 'maximum_allowed_tenants') }}
          </li>
          <li v-if="!editMode && resolveShowingScreening(unit.$model.last_showing_profile, 'minimum_lease_length')">
            <strong>Minimum lease length:</strong>
            {{ resolveShowingScreening(unit.$model.last_showing_profile, 'minimum_lease_length') }}
          </li>
          <li v-if="!editMode && unit.$model.bedrooms">
            <strong>Bedrooms</strong>
            {{ unit.$model.bedrooms }}
          </li>
          <li v-if="!editMode && unit.$model.bathrooms">
            <strong>Bathrooms:</strong>
            {{ unit.$model.bathrooms }}
          </li>
          <li v-if="!editMode && unit.$model.size">
            <strong>Size:</strong>
            {{ unit.$model.size }} square feet
          </li>
          <li v-if="!editMode && unit.$model.last_showing_profile && unit.$model.last_showing_profile.rent">
            <strong>Rent:</strong>
            ${{ unit.$model.last_showing_profile.rent }}
          </li>
        </ul>
      </div>
    </q-collapsible>
  </q-list>
</template>

<script>
import get from 'lodash.get';
import momentUtil from '@/utils/MomentUtil';
import Property from '@/constants/Property';
import { ShowingTypes, ShowingTypesDisplay } from '@/constants/ShowingProfile';
import { AccessHardware } from '@/constants/AccessHardware';
import { capitalizeFirstLetter } from '@/utils/CapitalizeFirstLetter';

const SHOWING_WINDOW_ASSIGNMENT_STRATEGY_LABELS = {
  priority: 'Priority',
  round_robin: 'Round Robin',
};

export default {
  name: 'UnitsList',
  props: {
    editMode: {
      type: Boolean,
      default: false,
    },
    currentProperty: {
      type: Object,
    },
    hasAppfolioNewIntergation: {
      type: Boolean,
      default: false,
    },
    validateProp: {
      type: Object,
    },
  },
  data() {
    const smartDeviceProviders = [AccessHardware.CODEBOX, AccessHardware.SENTRILOCK, AccessHardware.IGLOO];
    return {
      Property,
      ShowingTypesDisplay,
      AccessHardware,
      smartDeviceProviders,
      ShowingTypes,
    };
  },
  methods: {
    capitalizeFirstLetter,
    get,
    momentUtil,
    showingWindowAssigneeNames(showingWindow) {
      const names = (showingWindow.assignees || []).map((assignee) => assignee.full_name).filter(Boolean);
      if (names.length) {
        return names.join(', ');
      }
      return showingWindow.assignee_id ? showingWindow.assignee.full_name : 'Showdigs';
    },
    showingWindowAssignmentStrategyLabel(showingWindow) {
      if ((showingWindow.assignees || []).length < 2) {
        return null;
      }

      return SHOWING_WINDOW_ASSIGNMENT_STRATEGY_LABELS[showingWindow.assignment_strategy || 'priority'] || null;
    },
    getListingContact() {
      const listingManager = this.currentProperty.listing_manager;
      let result = '<strong>Listing contact: </strong>' + `${listingManager.full_name} - ` + '<a href="mailto:' + `${listingManager.email}">${listingManager.email}</a>`;
      if (listingManager.formatted_public_phone_number && listingManager.formatted_phone_number) {
        result += ` (Public - ${listingManager.formatted_public_phone_number}, Private - ${listingManager.formatted_phone_number})`;
      } else if (listingManager.formatted_public_phone_number) {
        result += ` (${listingManager.formatted_public_phone_number})`;
      }
      return result;
    },
    getTourBudgetSubLabel(showingProfile) {
      if (showingProfile.max_budgeted_tours != null) {
        return `Enabled. Showings will pause when there are ${showingProfile.max_budgeted_tours} paid tours for this unit (currently paid tours: ${showingProfile.paid_tours_count})`;
      }
      return 'Disabled. Showings will not be paused';
    },
    showEditBudgetModal(showingProfile) {
      this.$refs.editBudgetModal.display(showingProfile);
    },
    resolveShowingScreening(showingProfile, criteria) {
      if (showingProfile && showingProfile.screening_template) {
        return get(showingProfile, `screening_template.showing_screening.${criteria}`);
      }
      return get(showingProfile, `screening_criteria.${criteria}`);
    },
    resolvePropertyScreening(showingProfile, criteria) {
      if (showingProfile && showingProfile.screening_template) {
        return get(showingProfile, `screening_template.property_screening.${criteria}`);
      }
      return get(this.currentProperty, `screening_criteria.${criteria}`);
    },
    resolveSmartDevice(unit) {
      return unit.last_showing_profile
        && !unit.last_showing_profile.deleted_at
        && this.smartDeviceProviders.includes(unit.last_showing_profile.access_hardware)
        && unit.last_showing_profile.device;
    },
  },
};
</script>
<style scoped>
.notes-to-agent {
  white-space: pre-line;
}
</style>
